
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {

        if (this.readyState == 4 && this.status == 200) {

            var parse = JSON.parse(this.response)

            for (let i in parse.data.news) {
                const title = parse.data.news[i].title;
                const id = parse.data.news[i].id;
                const monthNames = ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"];
                const dateObj = new Date(parse.data.news[i].date);
                const month = monthNames[dateObj.getMonth()];
                const day = String(dateObj.getDate()).padStart(2, '0');
                const year = dateObj.getFullYear();
                const date = + day + ' ' + month + ' ' + year;

                const url = "https://otp.tools.investis.com/clients/uk/gb_group_plc/rns/regulatory-story.aspx?cid=2792&newsid=" + id;

                document.getElementById("investorNews").innerHTML += "<li><a href=\"" + url + "\" target=\"_blank\" class=\"tl-md mb-1 d-block\">" + title + "<p>" + date + "</p></a></li>";
            }

            var newsCount = 3;

        }
        }
    xhttp.open("GET", "https://api.investisdigital.com/news/v1/sources/2792/rns?limit=3&page=1&all=false", true);
    xhttp.setRequestHeader('accept', '*/*');
    xhttp.setRequestHeader('x-api-key', 'ccbe26c0-22e0-4897-8493-db2ef585f8a9');
    xhttp.send();
